import React from 'react'

import { classList } from 'react-classlist-helper'

import { PermitFieldType } from '~/client/graph/types.generated'
import { workflowFieldTypes } from '~/client/src/shared/constants/PermitFieldTypeConstants'

import { PERMIT_FIELD_GLYPHS } from './permitFieldGlyphs'

import './PermitFieldIcon.scss'

const ACCENT_FIELD_TYPES: ReadonlySet<PermitFieldType> = new Set(
  workflowFieldTypes,
)

interface IProps {
  fieldName: string
  className?: string
}

export default function PermitFieldIcon({
  fieldName,
  className,
}: IProps): JSX.Element {
  const Glyph = PERMIT_FIELD_GLYPHS[fieldName as PermitFieldType]
  if (!Glyph) {
    return null
  }

  return (
    <span
      className={classList({
        'row permit-field-icon brada4 pa4 no-grow': true,
        'tw:bg-field-accent': ACCENT_FIELD_TYPES.has(
          fieldName as PermitFieldType,
        ),
        [className]: !!className,
      })}
    >
      <Glyph />
    </span>
  )
}
